import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6ecdd1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-basic-search" }
const _hoisted_2 = { class: "search-products col-3 col-xl-2 position-relative" }
const _hoisted_3 = { class: "search-brands col-2 col-xl-2 position-relative" }
const _hoisted_4 = { class: "search-trademarks col-2 col-xl-2 position-relative" }
const _hoisted_5 = { class: "search-cnk col-2 col-xl-2 position-relative" }
const _hoisted_6 = { class: "search-submit col-2 offset-xl-2 d-flex justify-content-end align-items-start" }
const _hoisted_7 = {
  class: "btn btn-icon btn-primary mb-2",
  id: "btnSearchSubmit",
  type: "submit"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "search", -1))
const _hoisted_9 = {
  class: "row row-extensive-search align-items-center collapse mb-3",
  id: "extensiveSearch"
}
const _hoisted_10 = { class: "search-usage col-3 col-xxl-2 d-flex flex-row align-items-center" }
const _hoisted_11 = { class: "search-properties col-9 col-xxl-10 d-flex flex-row align-items-center mt-3" }
const _hoisted_12 = { class: "row row-footer" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = {
  type: "button",
  class: "btn btn-link collapsed p-0 me-3",
  id: "btnSearchExtensive",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#extensiveSearch",
  "aria-expanded": "false",
  "aria-controls": "extensiveSearch"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas ms-1" }, "expand_more", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas ms-1" }, "close", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createBlock(_component_dp_form, {
    onSubmit: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('submit'))),
    as: "form",
    novalidate: "",
    class: "bg-light rounded p-3"
  }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_input_text, {
            modelValue: _ctx.searchQueryProductName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQueryProductName) = $event)),
            placeholder: `${_ctx.$t('searchProduct')}...`,
            label: `${_ctx.$t('searchProduct')}`,
            name: `${_ctx.$t('searchProduct')}`,
            mode: "default",
            errors: errors
          }, null, 8, ["modelValue", "placeholder", "label", "name", "errors"]),
          (_ctx.hasSearchQuery('product_name'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-search-reset btn-close position-absolute h-100",
                type: "reset",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearSearch('product_name')))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_input_text, {
            modelValue: _ctx.searchQueryBrandName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQueryBrandName) = $event)),
            placeholder: `${_ctx.$t('searchLabo')}...`,
            label: `${_ctx.$t('searchLabo')}`,
            name: `${_ctx.$t('searchLabo')}`,
            mode: "default",
            errors: errors
          }, null, 8, ["modelValue", "placeholder", "label", "name", "errors"]),
          (_ctx.hasSearchQuery('brand_name'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-search-reset btn-close position-absolute h-100",
                type: "reset",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearSearch('brand_name')))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_input_text, {
            modelValue: _ctx.searchQueryTrademarkName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchQueryTrademarkName) = $event)),
            placeholder: `${_ctx.$t('searchTrademark')}...`,
            label: `${_ctx.$t('searchTrademark')}`,
            name: `${_ctx.$t('searchTrademark')}`,
            mode: "default",
            errors: errors
          }, null, 8, ["modelValue", "placeholder", "label", "name", "errors"]),
          (_ctx.hasSearchQuery('trademark_name'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-search-reset btn-close position-absolute h-100",
                type: "reset",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearSearch('trademark_name')))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_input_text, {
            modelValue: _ctx.searchQueryCnkCode,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchQueryCnkCode) = $event)),
            placeholder: `${_ctx.$t('searchCnkCode')}...`,
            label: `${_ctx.$t('searchCnkCode')}`,
            name: `${_ctx.$t('searchCnkCode')}`,
            mode: "default",
            errors: errors
          }, null, 8, ["modelValue", "placeholder", "label", "name", "errors"]),
          (_ctx.hasSearchQuery('cnk_code'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-search-reset btn-close position-absolute h-100",
                type: "reset",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearSearch('cnk_code')))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(_toDisplayString(_ctx.$t('search')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_input_select, {
            modelValue: _ctx.searchQueryUsageTypeCode,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchQueryUsageTypeCode) = $event)),
            label: _ctx.$t('usage'),
            name: _ctx.$t('usage'),
            selectText: _ctx.$t('selectText'),
            options: _ctx.usageTypeOptions,
            errors: errors
          }, null, 8, ["modelValue", "label", "name", "selectText", "options", "errors"]),
          (_ctx.hasSearchQuery('usage_type_code'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-search-reset btn-close mt-3 ms-3",
                type: "reset",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearSearch('usage_type_code')))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_input_checkbox_boolean, {
            modelValue: _ctx.searchQueryIsMedicine,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchQueryIsMedicine) = $event)),
            class: "me-4",
            label: _ctx.$t('medicines'),
            name: _ctx.$t('medicines'),
            errors: errors
          }, null, 8, ["modelValue", "label", "name", "errors"]),
          _createVNode(_component_input_checkbox_boolean, {
            modelValue: _ctx.searchQueryIsMedicalAid,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchQueryIsMedicalAid) = $event)),
            class: "me-4",
            label: _ctx.$t('medicalAids'),
            name: _ctx.$t('medicalAids'),
            errors: errors
          }, null, 8, ["modelValue", "label", "name", "errors"]),
          _createVNode(_component_input_checkbox_boolean, {
            modelValue: _ctx.searchQueryIsPrescriptionRequired,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchQueryIsPrescriptionRequired) = $event)),
            label: _ctx.$t('onPrescription'),
            name: _ctx.$t('onPrescription'),
            errors: errors
          }, null, 8, ["modelValue", "label", "name", "errors"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", _hoisted_14, [
            _createTextVNode(_toDisplayString(_ctx.$t('searchExtensive')), 1),
            _hoisted_15
          ]),
          _createElementVNode("button", {
            type: "reset",
            class: "btn btn-link p-0",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearSearch()))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('searchReset')), 1),
            _hoisted_16
          ])
        ])
      ])
    ]),
    _: 1
  }))
}